module.exports = __webpack_public_path__ + "img/vip_d_dark.75d1d9d5.svg";